import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
    PieChart,
    Pie,
    Cell,
    Tooltip,
    Legend
} from "recharts";

export default function ReactiveInductiveCapacitivePie({ deviceId, API_BASE }) {
    const { t } = useTranslation();
    const [enduktif, setEnduktif] = useState(0);
    const [kapasitif, setKapasitif] = useState(0);

    useEffect(() => {
        async function load() {
            try {
                // Toplam END / CAP özet verisi
                const res = await fetch(`${API_BASE}/reactive/summary?deviceId=${deviceId}`);
                const json = await res.json();

                setEnduktif(Math.trunc((Number(json.EL_SUM_END) || 0) * 1000) / 1000);
                setKapasitif(Math.trunc((Number(json.EL_SUM_CAP) || 0) * 1000) / 1000);

            } catch (err) {
                console.error("Pie ERROR:", err);
            }
        }

        load();
    }, [deviceId, API_BASE]);

    // Pie 0 değer olduğunda çökmemesi için
    const realEnd = enduktif > 0 ? enduktif : 0.001;
    const realCap = kapasitif > 0 ? kapasitif : 0.001;

    const data = [
        { name: t('energies.inductive'), value: realEnd },
        { name: t('energies.capacitive'), value: realCap },
    ];

    const COLORS = ["#3B82F6", "#F59E0B"]; // Mavi - Turuncu

    return (
        <div className="bg-white p-5 border rounded-xl shadow-sm">
            <h3 className="text-sm font-semibold text-slate-700 mb-3">
                {t('dashboard.reactiveEnergyDist')}
            </h3>

            <div className="flex items-center justify-center h-72">
                <PieChart width={300} height={300}>
                    <Pie
                        data={data}
                        cx="50%"
                        cy="60%"
                        outerRadius={110}
                        dataKey="value"
                    >
                        {data.map((_, i) => (
                            <Cell key={i} fill={COLORS[i]} />
                        ))}
                    </Pie>

                    <Tooltip formatter={(v) => `${Number(v).toFixed(3)} kVArh`} />

                    <Legend
                        layout="horizontal"
                        verticalAlign="bottom"
                        wrapperStyle={{ transform: "translateY(15px)" }}
                    />
                </PieChart>
            </div>
        </div>
    );
}
